import { ColocaStepper } from "@/shared/components/navigation/ColocaStepper";
import useTranslations from "@/shared/lang/useTranslations";

import { KYB_STEP_LABEL_KEYS, KYC_STEP_LABEL_KEYS } from "../constants/verification.constants";
import type { VerificationPurpose } from "../types/verification-api.types";

export interface VerificationStepperProps {
  purpose: VerificationPurpose;
  currentStep: number;
  totalSteps: number;
}

/**
 * Wraps `ColocaStepper` with the verification step labels and a mobile-only compact progress line ("n/5 ·
 * Step"). `ColocaStepper` already hides non-active labels on small screens.
 */
export function VerificationStepper({ purpose, currentStep, totalSteps }: VerificationStepperProps) {
  const { t } = useTranslations("verification");
  const labelKeys = purpose === "KYC" ? KYC_STEP_LABEL_KEYS : KYB_STEP_LABEL_KEYS;
  const steps = labelKeys.map((key) => ({ label: t(key) }));

  return (
    <div className="mb-6">
      <p className="mb-3 text-center text-xs font-medium text-muted-foreground sm:hidden">
        <span className="font-mono">
          {t("stepper_progress", { current: currentStep + 1, total: totalSteps })}
        </span>
        {" · "}
        {steps[currentStep]?.label}
      </p>
      <ColocaStepper
        steps={steps}
        currentStep={currentStep}
        aria-label={t("stepper_progress", { current: currentStep + 1, total: totalSteps })}
      />
    </div>
  );
}
